import React, { useEffect, useState } from "react";
import { Box, HStack, Text, Button, Badge } from "@chakra-ui/react";
import {
  isImpersonating,
  getImpersonationState,
  subscribeImpersonation,
  exitImpersonation,
} from "../utils/impersonation";

export default function ImpersonationBanner() {
  const [tick, setTick] = useState(0);
  useEffect(() => subscribeImpersonation(() => setTick((n) => n + 1)), []);

  if (!isImpersonating()) return null;
  const state = getImpersonationState();
  const t = state?.target || {};

  return (
    <Box
      position="sticky"
      top={0}
      // Below Chakra's modal/popover/dropdown layers (1400/1500/1000+) so popups
      // render above the banner. The banner is always visible during normal
      // browsing — only temporarily hidden when an explicit popup is open.
      zIndex={50}
      bg="orange.400"
      color="white"
      px={4}
      py={2}
      boxShadow="md"
      data-testid="impersonation-banner"
    >
      <HStack justify="space-between" spacing={4}>
        <HStack spacing={3} flexWrap="wrap">
          <Text fontWeight="bold" fontSize="sm">
            ⚠ Viewing as
          </Text>
          <Text fontWeight="bold">{t.name || t.email || t.id}</Text>
          {t.email && (
            <Text fontSize="sm" opacity={0.9}>
              {t.email}
            </Text>
          )}
          {t.role && (
            <Badge colorScheme="whiteAlpha" variant="solid">
              {t.role}
            </Badge>
          )}
          {t.active_schema && (
            <Badge colorScheme="whiteAlpha" variant="outline">
              {t.active_schema}
            </Badge>
          )}
        </HStack>
        <Button
          size="sm"
          colorScheme="whiteAlpha"
          variant="solid"
          onClick={() => { exitImpersonation(); }}
        >
          Exit
        </Button>
      </HStack>
    </Box>
  );
}
